import { Controller } from "@hotwired/stimulus";
import autofocus from "src/decidim/refactor/implementation/autofocus";
export default class extends Controller {
  connect() {
    this.handleChange = this.handleChange.bind(this);
    this.element.addEventListener("change", this.handleChange);
    this.tabsContent = this.element.parentElement.parentElement.nextElementSibling;
    this.setActiveTab(this.element.value);
  }
  disconnect() {
    this.element.removeEventListener("change", this.handleChange);
  }
  setActiveTab(targetTabPaneSelector) {
    if (!this.tabsContent) {
      return;
    }
    let activeTabContent = this.tabsContent.querySelector(".is-active");
    if (activeTabContent) {
      activeTabContent.ariaHidden = "true";
      activeTabContent.classList.remove("is-active");
    }
    let activePane = this.tabsContent.querySelector(targetTabPaneSelector);
    if (activePane) {
      activePane.ariaHidden = "false";
      activePane.classList.add("is-active");
    }
  }
  handleChange(event) {
    this.setActiveTab(event.target.value);
    let activePane = this.tabsContent.querySelector(event.target.value);
    autofocus(activePane);
  }
}
